"use client";
import * as React from "react";
import { useState, useEffect } from "react";

function TrustedClients() {
  const clients = [
    {
      name: "Akkodis",
      logo: "https://cdn.acsdev.in/Vasta/Akkodis_logo.svg"
    },
    {
      name: "Beacon Hill",
      logo: "https://cdn.acsdev.in/Vasta/Beacon Hill Logo.webp"
    },
    {
      name: "Kaizen Analytix",
      logo: "https://cdn.acsdev.in/Vasta/Kaizen Analytix.png"
    },
    {
      name: "Resolve Tech",
      logo: "https://cdn.acsdev.in/Vasta/Resolve Tech.png"
    },
    {
      name: "Synechron",
      logo: "https://cdn.acsdev.in/Vasta/Synechron_Logo.jpg.jpeg"
    },
    {
      name: "Tays Inc",
      logo: "https://cdn.acsdev.in/Vasta/Tays Inc.png"
    },
    {
      name: "VM",
      logo: "https://cdn.acsdev.in/Vasta/VM_Logo.jpg.jpeg"
    },
    {
      name: "Vy Systems",
      logo: "https://cdn.acsdev.in/Vasta/Vy Systems.jpg.jpeg"
    }
  ];

  const [currentHighlightIndex, setCurrentHighlightIndex] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  // Auto-highlighting effect that pauses when hovering
  useEffect(() => {
    if (isHovered) return; // Don't run auto-highlight when hovering

    const interval = setInterval(() => {
      setCurrentHighlightIndex((prevIndex) =>
        prevIndex === clients.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000); // Change highlight every 2 seconds

    return () => clearInterval(interval);
  }, [clients.length, isHovered]);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
    setIsHovered(false);
  };

  const isCardHighlighted = (index) => {
    if (isHovered) {
      return hoveredIndex === index;
    }
    return currentHighlightIndex === index;
  };

  return (
    <section className="relative py-10 bg-white overflow-hidden">
      {/* Top Curved Divider */}
      <div className="absolute top-0 left-0 right-0">
        <svg viewBox="0 0 1200 80" className="w-full h-auto">
          <path
            d="M0,40 C300,0 500,80 800,40 C1000,10 1100,60 1200,40 L1200,0 L0,0 Z"
            fill="white"
          />
        </svg>
      </div>

      {/* Subtle Background Blobs */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute top-10 left-1/4 w-64 h-64 rounded-full opacity-5 blur-3xl"
          style={{ background: 'radial-gradient(circle, #1719A8 0%, transparent 70%)' }}
        ></div>
        <div
          className="absolute bottom-10 right-1/4 w-48 h-48 rounded-full opacity-5 blur-2xl"
          style={{ background: 'radial-gradient(circle, #D96F2B 0%, transparent 70%)' }}
        ></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pb-8">
        <div className="text-center mb-8">
          {/* <div className="inline-flex items-center px-6 py-3 bg-[#E8ECFF] border border-[#E2E8F0] rounded-full mb-6">
            <span className="w-2 h-2 bg-[#1719A8] rounded-full mr-3"></span>
            <span style={{ color: '#1719A8' }} className="text-sm font-bold uppercase tracking-wider">
              Trusted Worldwide
            </span>
            
          </div> */}
          <div className="inline-flex items-center px-4 py-2 lg:px-6 lg:py-2 md:px-4 md:py-1.5 sm:px-3 sm:py-1 bg-[#1719A8]/90 backdrop-blur-md border border-[#1719A8]/60 rounded-full mb-3 shadow-lg">
            <span
              className="w-2 h-2 bg-white rounded-full mr-3 animate-pulse"
              aria-hidden="true"
            ></span>
            <span className="text-xs md:text-sm lg:text-sm sm:text-xs text-white font-semibold uppercase tracking-wider">
              Trusted Worldwide
            </span>
          </div>

          <h2 className="text-5xl lg:text-6xl  font-black mb-3" style={{ color: '#1E293B' }}>
            Our Vendor
            <span
              className="block leading-snug bg-gradient-to-r bg-clip-text text-transparent"
              style={{
                backgroundImage: 'linear-gradient(135deg, rgb(23, 25, 168) 0%, rgb(217, 111, 43) 50%, rgb(201, 197, 26) 100%)'
              }}
            >
              Partners
            </span>
          </h2>

          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#64748B' }}>
            Join the forward-thinking organizations that trust us
             to drive their digital transformation initiatives.
          </p>
        </div>

        {/* Client Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4 items-center justify-items-center">
          {clients.map((client, index) => (
            <div
              key={index}
              className={`group relative w-32 h-32 bg-white/60 backdrop-blur-sm rounded-2xl border transition-all duration-500 flex items-center justify-center p-4 cursor-pointer ${
                isCardHighlighted(index)
                  ? 'border-2 border-[#1719A8] scale-110 shadow-lg'
                  : 'border-[#E2E8F0] hover:border-[#1719A8] hover:scale-110 hover:shadow-lg'
              }`}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={client.logo}
                alt={`${client.name} logo`}
                className={`max-w-full max-h-full object-contain transition-all duration-500 ${
                  isCardHighlighted(index)
                    ? 'filter-none'
                    : 'filter grayscale group-hover:grayscale-0'
                }`}
                loading="lazy"
              />

              {/* Tooltip */}
              <div className={`absolute -bottom-12 left-1/2 transform -translate-x-1/2 bg-[#1E293B] text-white px-3 py-1 rounded-lg text-sm transition-opacity duration-300 whitespace-nowrap pointer-events-none ${
                isCardHighlighted(index)
                  ? 'opacity-100'
                  : 'opacity-0 group-hover:opacity-100'
              }`}>
                {client.name}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Curved Divider */}
      {/* <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1200 80" className="w-full h-auto">
          <defs>
            <linearGradient id="bottomGradient" x1="0%" y1="0%" x2="100%" y2="0%" gradientTransform="rotate(135)">
              <stop offset="0%" stopColor="#1719A8" />
              <stop offset="100%" stopColor="#0F1280" />
            </linearGradient>
          </defs>
          <path
            d="M0,40 C300,80 500,0 800,40 C1000,70 1100,20 1200,40 L1200,80 L0,80 Z"
            fill="url(#bottomGradient)"
          />
        </svg>
      </div> */}
    </section>
  );
}

export default TrustedClients;
